import ApiBudgety from '@/api/apiBudgety'
import { MenusSistema } from '@/Helper/Segurity'

export const perfilService = {
  guardarPerfil,
  getPerfiles,
  deleteUsuarioPerfil,
  asignarPerfilUsuario,
  getPerfilByIdUsuario,
  getPerfilSinAsignarByIdUsuario,
}

async function getPerfiles() {
  return await ApiBudgety.get('Perfil/GetAll')
}

async function guardarPerfil(perfil) {
  return await ApiBudgety.post('Perfil/InsertOrUpdate/', perfil, {
    headers: {
      ACCION: MenusSistema.permisos_perfiles.accesos.crear_editar_perfil,
      MENU: MenusSistema.permisos_perfiles.id,
    },
  })
}

async function deleteUsuarioPerfil(body) {
  return await ApiBudgety.post('Perfil/EliminarPerfilUsuario', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.editar_perfiles_asignados,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

async function asignarPerfilUsuario(body) {
  return await ApiBudgety.post('Perfil/AsignarUsuario', body, {
    headers: {
      ACCION: MenusSistema.permisos_usuario.accesos.editar_perfiles_asignados,
      MENU: MenusSistema.permisos_usuario.id,
    },
  })
}

async function getPerfilByIdUsuario(id) {
  return await ApiBudgety.get('Perfil/FindByIdUsuario/' + id)
}

async function getPerfilSinAsignarByIdUsuario(id) {
  return await ApiBudgety.get('Perfil/FindSinAsignarByIdUsuario/' + id)
}
